var MENU_ERRORS = {
    context: "Menu component was not found in the tree",
    children: "Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
};
export { MENU_ERRORS }; //# sourceMappingURL=Menu.errors.js.map
